import React from 'react';
import { Grid } from '@material-ui/core';
import { Email } from '@material-ui/icons';
import { Link } from 'react-router-dom';
import useChangePageTitle from '../CustomHooks/useChangePageTitle';
import './ContactUs.css';

const ContactUs = () => {
  useChangePageTitle('ContactUs');

  return (
    <div className="contactUsRoot">
      <div className="contactUsHero">
        <h2 className="contactUsHeroTitle">Contact Us</h2>
        <p className="contactUsHeroSubtitle">
          Have a question or need help? Our team is here to support you.
        </p>
      </div>

      <Grid container spacing={3} justify="center">
        <Grid item xs={12} md={6}>
          <div className="contactUsCard">
            <div className="contactUsCardContent">
              <div className="contactUsIconWrapper contactUsIconEmail">
                <Email />
              </div>
              <h3 className="contactUsCardTitle">Email Support</h3>
              <p className="contactUsCardBody">
                Send us an email and our support team will get back to you as soon as possible.
              </p>
              <Link to="/email" className="contactUsLink">
                support@phishcloud.com
              </Link>
            </div>
          </div>
        </Grid>
      </Grid>
    </div>
  );
};
export default ContactUs;
